//TODO : Refactor after ai
import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "../types";

/** [tint, accent, ink] per tone. */
const HUE: Record<ToneColor, [string, string, string]> = {
  brand: ["var(--brand-50)", "var(--brand-600)", "var(--brand-700)"],
  success: ["var(--success-50)", "var(--success-500)", "var(--success-700)"],
  warning: ["var(--warning-50)", "var(--warning-500)", "var(--warning-700)"],
  error: ["var(--error-50)", "var(--error-500)", "var(--error-700)"],
  info: ["var(--info-50)", "var(--info-500)", "var(--info-700)"],
  violet: ["var(--violet-50)", "var(--violet-500)", "var(--violet-700)"],
  neutral: ["var(--neutral-50)", "var(--neutral-400)", "var(--text-secondary)"],
};

export interface CalendarEventProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title: ReactNode;
  time?: ReactNode;
  color?: ToneColor;
  variant?: "block" | "dot";
  height?: number;
  style?: CSSProperties;
}

/** Event block in a calendar grid. */
export function CalendarEvent({
  title,
  time,
  color = "brand",
  variant = "block",
  height,
  className = "",
  style,
  ...rest
}: CalendarEventProps) {
  const [bg, accent, fg] = HUE[color] ?? HUE.brand;

  if (variant === "dot") {
    return (
      <div
        className={className}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          font: "var(--t-caption-m)",
          color: "var(--text-secondary)",
          overflow: "hidden",
          ...style,
        }}
        {...rest}
      >
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: accent,
            flexShrink: 0,
          }}
        />
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {title}
        </span>
        {time && <span style={{ color: "var(--text-tertiary)", flexShrink: 0 }}>{time}</span>}
      </div>
    );
  }

  return (
    <div
      className={className}
      style={{
        background: bg,
        color: fg,
        borderRadius: "var(--r-xs)",
        padding: "6px 8px",
        boxShadow: `inset 3px 0 0 0 ${accent}`,
        height,
        overflow: "hidden",
        cursor: "pointer",
        ...style,
      }}
      {...rest}
    >
      <div
        style={{
          fontFamily: "var(--font-ui-label)",
          fontWeight: 500,
          fontSize: 12,
          lineHeight: "16px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </div>
      {time && <div style={{ font: "var(--t-caption-s)", opacity: 0.75 }}>{time}</div>}
    </div>
  );
}
